export default {
    parts: [],
    baseStyle: (props) => ({
        carouselImageWrapper: {
            width: '100%',
            backgroundColor: props?.BackgroundColor || 'unset',
            // Always enforce aspect ratio to prevent layout shifts between tabs
            aspectRatio: {base: '140/210', lg: '180/265'},
            overflow: 'hidden',
            // Make images cover the container while maintaining aspect ratio
            '& picture': {
                display: 'block',
                width: '100%',
                height: '100%'
            },
            '& img': {
                width: '100%',
                height: '100%',
                objectFit: 'cover'
            }
        },
        link: {
            fontSize: {base: 'sm'},
            lineHeight: {base: '100%'},
            fontWeight: {base: 'medium'},
            textDecoration: {base: props?.Underline ? 'underline' : 'none'}
        },
        carouselItem: {
            padding: 0,
            maxWidth: {lg: 'container.xxxl'},
            margin: '0 auto'
        }
    })
}
